import Vue from 'vue'
import Vuex from 'vuex'

import carrinho from './modules/carrinho'
import usuario from './modules/usuario'
import finalizarCompra from './modules/finalizar-compra'
import menu from './modules/menu'
import configuracoes from './modules/configuracoes'
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'

var expirarOitoMinutos = new Date(new Date().getTime() + 7.5 * 60 * 1000)

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { carrinho, usuario, finalizarCompra, menu, configuracoes },
  plugins: [createPersistedState({
    storage: {
      getItem: (key) => Cookies.get(key),
      setItem: (key, value) =>
        Cookies.set(key, value, { expires: expirarOitoMinutos, secure: true }),
      removeItem: (key) => Cookies.remove(key)
    },
    paths: ['carrinho', 'finalizarCompra', 'menu']
  })]
})



// WEBPACK FOOTER //
// ./src/store/store.js